(function() {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════
  // CONFIGURATION — replace EDGE_URL + ANON_KEY for your Supabase project
  // ═══════════════════════════════════════════════════════════════════
  var EDGE_URL = 'https://djcjoiwghgrmejdsgake.supabase.co/functions/v1/vyva-chat';
  var ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRqY2pvaXdnaGdybWVqZHNnYWtlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU2MzkwNjYsImV4cCI6MjA5MTIxNTA2Nn0.0R4rfoUXKAEoXHGsciOx2kbEdmjBDs7pvdGYyCHUOYk';

  var QUICK_REPLIES = [
    'Take the Cellular Match',
    'How does Vflex work?',
    'Build my daily ritual',
    'Shipping & returns'
  ];

  // ═══════════════════════════════════════════════════════════════════
  // BRAND TOKENS (V4.3 locked palette — DO NOT MODIFY)
  // ═══════════════════════════════════════════════════════════════════
  var TOKENS = {
    bgPage:        '#F8F6F2',     // warm cream
    bgCard:        '#FFFFFF',
    bgAccent:      '#F1E5D0',     // warm beige
    brownDark:     '#392E1B',     // primary text + buttons
    brownWarm:     '#905C04',     // accent text, badges
    brownWarmBg:   'rgba(144, 92, 4, 0.10)',
    textBody:      'rgba(57, 46, 27, 0.81)',
    borderSoft:    '#DFDFDF',
    greenSuccess:  '#2F6F4F'      // success-state icons only
  };

  var messages = [];
  var loading = false;
  var open = false;

  // ═══════════════════════════════════════════════════════════════════
  // STYLES (brand-locked)
  // ═══════════════════════════════════════════════════════════════════
  var style = document.createElement('style');
  style.textContent = [
    "@import url('https://rsms.me/inter/inter.css');",
    "@keyframes vyva-bounce{0%,60%,100%{transform:translateY(0);opacity:.35}30%{transform:translateY(-5px);opacity:1}}",
    "@keyframes vyva-fade{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}",
    "#vyva-widget *{box-sizing:border-box;margin:0;padding:0;font-family:'Inter','Harmonia Sans',system-ui,-apple-system,sans-serif;-webkit-font-smoothing:antialiased;}",
    "#vyva-widget button{font-family:inherit;}",
    "#vyva-chat-window{width:380px;max-width:calc(100vw - 32px);height:560px;max-height:calc(100vh - 120px);border-radius:20px;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 12px 40px rgba(57,46,27,0.18),0 4px 12px rgba(57,46,27,0.08);margin-bottom:12px;background:" + TOKENS.bgPage + ";border:1px solid " + TOKENS.borderSoft + ";animation:vyva-fade .3s ease-out;}",
    "#vyva-chat-header{background:#FFFFFF;padding:18px 20px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid " + TOKENS.borderSoft + ";}",
    "#vyva-chat-header .hdr-left{display:flex;align-items:center;gap:12px;}",
    "#vyva-chat-header .hdr-right{display:flex;align-items:center;gap:6px;}",
    "#vyva-chat-header .hdr-mark{font-family:'Inter',serif;font-weight:700;font-size:22px;color:" + TOKENS.brownDark + ";letter-spacing:-0.02em;line-height:1;}",
    "#vyva-chat-header .hdr-meta{display:flex;flex-direction:column;}",
    "#vyva-chat-header .hdr-title{color:" + TOKENS.brownDark + ";font-weight:600;font-size:13px;line-height:1.2;}",
    "#vyva-chat-header .hdr-sub{color:" + TOKENS.brownWarm + ";font-size:10px;font-weight:500;letter-spacing:0.12em;text-transform:uppercase;margin-top:2px;}",
    "#vyva-chat-header .hdr-close{background:none;border:none;color:" + TOKENS.brownDark + ";font-size:18px;cursor:pointer;padding:6px;line-height:1;border-radius:6px;transition:background .15s;}",
    "#vyva-chat-header .hdr-close:hover{background:" + TOKENS.brownWarmBg + ";}",
    "#vyva-chat-header .hdr-reset{background:" + TOKENS.brownWarmBg + ";border:none;color:" + TOKENS.brownWarm + ";font-size:10px;cursor:pointer;padding:6px 12px;border-radius:50px;font-weight:600;letter-spacing:0.04em;}",
    "#vyva-chat-msgs{flex:1;overflow-y:auto;padding:20px 20px 12px;scrollbar-width:thin;scrollbar-color:" + TOKENS.borderSoft + " transparent;}",
    "#vyva-chat-msgs::-webkit-scrollbar{width:6px;}",
    "#vyva-chat-msgs::-webkit-scrollbar-thumb{background:" + TOKENS.borderSoft + ";border-radius:3px;}",
    ".vyva-msg{display:flex;margin-bottom:12px;}",
    ".vyva-msg-user{justify-content:flex-end;}",
    ".vyva-msg-bot{justify-content:flex-start;}",
    ".vyva-bubble{max-width:82%;padding:12px 16px;font-size:14px;line-height:1.55;white-space:pre-wrap;word-break:break-word;animation:vyva-fade .25s ease-out;}",
    ".vyva-bubble-user{border-radius:18px 18px 6px 18px;background:" + TOKENS.brownDark + ";color:#FFFFFF;}",
    ".vyva-bubble-bot{border-radius:18px 18px 18px 6px;background:" + TOKENS.bgCard + ";color:" + TOKENS.brownDark + ";border:1px solid " + TOKENS.borderSoft + ";box-shadow:0 1px 3px rgba(57,46,27,0.04);}",
    ".vyva-bubble-bot strong{font-weight:600;color:" + TOKENS.brownDark + ";}",
    ".vyva-welcome{background:" + TOKENS.bgCard + ";border:1px solid " + TOKENS.borderSoft + ";border-radius:18px;padding:18px 18px 16px;margin-bottom:16px;font-size:14px;line-height:1.6;color:" + TOKENS.brownDark + ";box-shadow:0 1px 3px rgba(57,46,27,0.04);}",
    ".vyva-welcome .v-eyebrow{font-size:10px;font-weight:600;color:" + TOKENS.brownWarm + ";letter-spacing:0.18em;text-transform:uppercase;margin-bottom:8px;}",
    ".vyva-welcome .v-greeting{font-weight:600;margin-bottom:4px;}",
    ".vyva-qr-wrap{display:flex;flex-direction:column;gap:8px;}",
    ".vyva-qr{background:" + TOKENS.bgCard + ";border:1px solid " + TOKENS.borderSoft + ";border-radius:10px;padding:12px 14px;font-size:13px;color:" + TOKENS.brownDark + ";cursor:pointer;font-weight:500;text-align:left;transition:all .15s;display:flex;align-items:center;justify-content:space-between;}",
    ".vyva-qr:hover{background:" + TOKENS.brownDark + ";color:#FFFFFF;border-color:" + TOKENS.brownDark + ";transform:translateY(-1px);box-shadow:0 4px 12px rgba(57,46,27,0.12);}",
    ".vyva-qr:hover .v-arrow{transform:translateX(2px);}",
    ".vyva-qr .v-arrow{font-size:14px;opacity:.6;transition:transform .15s;}",
    ".vyva-typing{display:flex;gap:5px;background:" + TOKENS.bgCard + ";border-radius:18px 18px 18px 6px;padding:14px 18px;border:1px solid " + TOKENS.borderSoft + ";align-items:center;}",
    ".vyva-dot{width:6px;height:6px;border-radius:50%;background:" + TOKENS.brownDark + ";display:inline-block;animation:vyva-bounce 1.2s infinite;}",
    "#vyva-chat-input-bar{padding:14px 16px 12px;border-top:1px solid " + TOKENS.borderSoft + ";display:flex;gap:8px;background:" + TOKENS.bgCard + ";align-items:center;}",
    "#vyva-chat-input{flex:1;border:1px solid " + TOKENS.borderSoft + ";border-radius:10px;padding:11px 14px;font-size:14px;outline:none;background:" + TOKENS.bgCard + ";color:" + TOKENS.brownDark + ";transition:border-color .15s;}",
    "#vyva-chat-input::placeholder{color:" + TOKENS.brownDark + ";opacity:.45;}",
    "#vyva-chat-input:focus{border-color:" + TOKENS.brownDark + ";}",
    "#vyva-chat-input:disabled{background:" + TOKENS.bgPage + ";opacity:.6;}",
    "#vyva-send-btn{background:" + TOKENS.brownDark + ";color:#FFFFFF;border:none;border-radius:10px;width:42px;height:42px;cursor:pointer;font-size:18px;display:flex;align-items:center;justify-content:center;transition:opacity .15s;}",
    "#vyva-send-btn:disabled{background:" + TOKENS.borderSoft + ";cursor:default;}",
    "#vyva-send-btn:not(:disabled):hover{opacity:.92;}",
    "#vyva-chat-footer{text-align:center;padding:8px 0 12px;font-size:10px;color:" + TOKENS.brownDark + ";opacity:.55;background:" + TOKENS.bgCard + ";letter-spacing:0.04em;}",
    "#vyva-chat-footer a{color:" + TOKENS.brownDark + ";text-decoration:none;font-weight:500;}",
    "#vyva-chat-footer .v-sep{margin:0 6px;opacity:.4;}",
    "#vyva-fab{width:56px;height:56px;border-radius:50%;background:" + TOKENS.brownDark + ";border:none;cursor:pointer;box-shadow:0 8px 24px rgba(57,46,27,0.28),0 2px 6px rgba(57,46,27,0.12);display:flex;align-items:center;justify-content:center;transition:all .25s cubic-bezier(.4,0,.2,1);margin-left:auto;color:#FFFFFF;}",
    "#vyva-fab:hover{transform:translateY(-2px) scale(1.04);box-shadow:0 12px 32px rgba(57,46,27,0.34),0 4px 10px rgba(57,46,27,0.16);}",
    "#vyva-fab svg{width:24px;height:24px;}",
    "#vyva-fab-label{position:absolute;right:72px;top:50%;transform:translateY(-50%);background:" + TOKENS.brownDark + ";color:#FFFFFF;padding:8px 14px;border-radius:50px;font-size:13px;font-weight:500;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity .2s;letter-spacing:0.01em;box-shadow:0 4px 12px rgba(57,46,27,0.18);}",
    "#vyva-fab:hover ~ #vyva-fab-label{opacity:1;}",
    // Mobile responsive
    "@media (max-width:480px){",
    "  #vyva-widget{bottom:16px !important;right:16px !important;}",
    "  #vyva-chat-window{width:calc(100vw - 32px);height:calc(100vh - 96px);max-height:calc(100vh - 96px);border-radius:18px;}",
    "  #vyva-fab{width:52px;height:52px;}",
    "  #vyva-fab-label{display:none;}",
    "}"
  ].join('\n');
  document.head.appendChild(style);

  // ═══════════════════════════════════════════════════════════════════
  // DOM CONSTRUCTION
  // ═══════════════════════════════════════════════════════════════════
  var root = document.createElement('div');
  root.id = 'vyva-widget';
  root.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:9999;';

  var chatWindow = document.createElement('div');
  chatWindow.id = 'vyva-chat-window';
  chatWindow.style.display = 'none';
  chatWindow.innerHTML = [
    '<div id="vyva-chat-header">',
    '  <div class="hdr-left">',
    '    <div class="hdr-mark">VyVa</div>',
    '    <div class="hdr-meta">',
    '      <div class="hdr-title">Cellular Wellness Educator</div>',
    '      <div class="hdr-sub">Science-Driven Wellness</div>',
    '    </div>',
    '  </div>',
    '  <div class="hdr-right">',
    '    <button class="hdr-reset" style="display:none">Start over</button>',
    '    <button class="hdr-close" aria-label="Close chat">×</button>',
    '  </div>',
    '</div>',
    '<div id="vyva-chat-msgs" role="log" aria-live="polite"></div>',
    '<form id="vyva-chat-input-bar">',
    '  <input id="vyva-chat-input" placeholder="Ask about cellular wellness…" aria-label="Type your message" />',
    '  <button id="vyva-send-btn" type="submit" aria-label="Send message">↑</button>',
    '</form>',
    '<div id="vyva-chat-footer">',
    '  <a href="https://vyva.global" target="_blank" rel="noopener">vyva.global</a>',
    '  <span class="v-sep">·</span>',
    '  Educational only · Not medical advice',
    '</div>'
  ].join('');

  var fab = document.createElement('button');
  fab.id = 'vyva-fab';
  fab.setAttribute('aria-label', 'Open VyVa Cellular Wellness chat');
  fab.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var fabLabel = document.createElement('div');
  fabLabel.id = 'vyva-fab-label';
  fabLabel.textContent = 'Ask the Wellness Educator';

  root.appendChild(chatWindow);
  root.appendChild(fab);
  root.appendChild(fabLabel);
  document.body.appendChild(root);

  var msgsEl = chatWindow.querySelector('#vyva-chat-msgs');
  var inputEl = chatWindow.querySelector('#vyva-chat-input');
  var sendBtn = chatWindow.querySelector('#vyva-send-btn');
  var closeBtn = chatWindow.querySelector('.hdr-close');
  var resetBtn = chatWindow.querySelector('.hdr-reset');
  var form = chatWindow.querySelector('#vyva-chat-input-bar');

  // ═══════════════════════════════════════════════════════════════════
  // BEHAVIOR
  // ═══════════════════════════════════════════════════════════════════
  function toggle() {
    open = !open;
    chatWindow.style.display = open ? 'flex' : 'none';
    fab.innerHTML = open
      ? '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (open) { inputEl.focus(); render(); }

    // Analytics hook (Shopify dataLayer if available)
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'vyva_chatbot_' + (open ? 'opened' : 'closed') });
    }
  }

  fab.addEventListener('click', toggle);
  closeBtn.addEventListener('click', toggle);
  resetBtn.addEventListener('click', function() {
    messages = [];
    loading = false;
    render();
  });

  function escapeHtml(t) {
    var d = document.createElement('div');
    d.textContent = t;
    return d.innerHTML;
  }

  function formatMessage(t, isUser) {
    var html = escapeHtml(t).replace(/\n/g, '<br>');
    if (!isUser) {
      html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      html = html.replace(/(https?:\/\/[^\s<>&"')\]]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer" style="color:' + TOKENS.brownWarm + ';text-decoration:underline;word-break:break-all;">$1</a>');
    }
    return html;
  }

  function render() {
    var html = '';
    if (messages.length === 0 && !loading) {
      html += '<div class="vyva-welcome">';
      html += '  <div class="v-eyebrow">VyVa Cellular Wellness Educator</div>';
      html += '  <div class="v-greeting">Hi — I\'m here to help.</div>';
      html += '  Ask me about our supplements, the cellular nutrition science behind them, or let\'s find the right ritual for you.';
      html += '</div>';
      html += '<div class="vyva-qr-wrap">';
      QUICK_REPLIES.forEach(function(qr) {
        html += '<button class="vyva-qr" data-qr="' + qr.replace(/"/g, '&quot;') + '">';
        html += '  <span>' + qr + '</span>';
        html += '  <span class="v-arrow">→</span>';
        html += '</button>';
      });
      html += '</div>';
    }
    messages.forEach(function(m) {
      var isUser = m.role === 'user';
      html += '<div class="vyva-msg ' + (isUser ? 'vyva-msg-user' : 'vyva-msg-bot') + '">';
      html += '  <div class="vyva-bubble ' + (isUser ? 'vyva-bubble-user' : 'vyva-bubble-bot') + '">' + formatMessage(m.content, isUser) + '</div>';
      html += '</div>';
    });
    if (loading) {
      html += '<div class="vyva-msg vyva-msg-bot"><div class="vyva-typing"><span class="vyva-dot"></span><span class="vyva-dot" style="animation-delay:.2s"></span><span class="vyva-dot" style="animation-delay:.4s"></span></div></div>';
    }
    msgsEl.innerHTML = html;
    msgsEl.scrollTop = msgsEl.scrollHeight;

    msgsEl.querySelectorAll('.vyva-qr').forEach(function(btn) {
      btn.addEventListener('click', function() { send(btn.getAttribute('data-qr')); });
    });

    sendBtn.disabled = loading || !inputEl.value.trim();
    inputEl.disabled = loading;
    resetBtn.style.display = messages.length > 0 ? 'inline-block' : 'none';
  }

  async function send(text) {
    if (!text || !text.trim() || loading) return;
    messages.push({ role: 'user', content: text.trim() });
    inputEl.value = '';
    loading = true;
    render();

    // Analytics hook
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'vyva_chatbot_message_sent', message_count: messages.length });
    }

    try {
      var res = await fetch(EDGE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + ANON_KEY,
          'apikey': ANON_KEY
        },
        body: JSON.stringify({ messages: messages })
      });
      if (!res.ok) {
        if (res.status === 429) {
          throw new Error('rate_limit');
        }
        throw new Error('Status ' + res.status);
      }
      var data = await res.json();
      messages.push({ role: 'assistant', content: data.reply || 'I\'m sorry, I couldn\'t process that just now.' });
    } catch (e) {
      var errorMsg = e.message === 'rate_limit'
        ? 'I\'m a bit busy at the moment — please try again in a few seconds.'
        : 'I\'m having trouble connecting. Please try again, or reach our team at support@vyva.global.';
      messages.push({ role: 'assistant', content: errorMsg });
    }
    loading = false;
    render();
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    send(inputEl.value);
  });

  inputEl.addEventListener('input', function() {
    sendBtn.disabled = loading || !inputEl.value.trim();
  });

  // Enter to send
  inputEl.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });

  render();
})();